export const GET_BRAND = 'GET_BRAND [self_portal]';
export const GET_DEVICES = 'GET_DEVICES [self_portal]';
export const DESTROY_ACCOUNT = 'DESTROY_ACCOUNT [self_portal]';
export const DESTROY_ANY_MAIL_ACCOUNT = 'DESTROY_ANY_MAIL_ACCOUNT [self_portal]';
export const GET_DESTROY_STATUS = 'GET_DESTROY_STATUS [self_portal]';
export const GET_ACCOUNT_PII = 'GET_ACCOUNT_PII [self_portal]';
export const DELETE_SHARE = 'DELETE_SHARE [self_portal]';
export const GET_ANY_MAIL_ACCOUNT_PII = 'GET_ANY_MAIL_ACCOUNT_PII [self_portal]';
export const SET_COMMAND = 'SET_COMMAND [self_portal]';
export const GET_ACCOUNT_PII_STATUS = 'GET_ACCOUNT_PII_STATUS [self_portal]';
export const GET_ANY_MAIL_ACCOUNT_PII_STATUS = 'GET_ANY_MAIL_ACCOUNT_PII_STATUS [self_portal]';
export const GET_ENV = 'GET_ENV [self_portal]';



// WEBPACK FOOTER //
// ./src/redux/types.js